import * as React from "react";
import {useEffect, useState} from "react";
import {collection, onSnapshot} from "firebase/firestore";
import {db} from "./Admin";
import css from "../css/admin.module.css";
import {post} from "./post";
import DialogMUI from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {AppComponent} from "../App";


const Dialog = ({open, json, children, setOpen}) => {
    return (
        <DialogMUI fullWidth={true} maxWidth={"lg"} onClose={() => setOpen(false)} open={!!open}>
            <DialogTitle sx={{m: 0, p: 2}}>LifePay Invoice</DialogTitle>
            <IconButton title={"Закрыть"} onClick={() => setOpen(false)} sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500]
            })}><CloseIcon/></IconButton>
            <DialogContent dividers>
                    <pre>
                        {JSON.stringify(json, null, "  ")}
                    </pre>
            </DialogContent>
            <DialogActions>
                {children}
                <Button id={"closeDialog"} autoFocus onClick={() => setOpen(false)}>Закрыть</Button>
            </DialogActions>
        </DialogMUI>
    )
}

export const Invoices = () => {
    const [json, setJSON] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const unsubscribes = [];
        unsubscribes.push(onSnapshot(collection(db, "invoices"), s => setInvoices(s.docs.map(doc => doc.data()))));
        return () => unsubscribes.forEach(unsubscribe => unsubscribe())
    }, []);

    invoices.sort((a, b) => a.created - b.created);

    const showAcquiringInvoice = async (acquiringInvoiceId) => {
        AppComponent.SetLoading(true);
        setJSON(await post("lifePayInvoice", {acquiringInvoiceId}));
        setOpen(true);
        AppComponent.SetLoading(false);
    }
    const showAcquiringInvoiceRefund = async (acquiringInvoiceId, acquiringInvoiceRefundId) => {
        AppComponent.SetLoading(true);
        setJSON(await post("lifePayInvoiceRefundStatus", {acquiringInvoiceId, acquiringInvoiceRefundId}));
        setOpen(true);
        AppComponent.SetLoading(false);
    }
    const onAcquiringInvoiceRefundClick = async (invoiceId, acquiringInvoiceId, amount) => {
        AppComponent.SetLoading(true);

        if (window.confirm("Вернуть?")) {
            setJSON(await post("lifePayInvoiceRefund", {invoiceId, acquiringInvoiceId, amount}));
            setOpen(true);
        }

        AppComponent.SetLoading(false);
    }

    const onInvoiceDelete = async (invoiceId) => {

        AppComponent.SetLoading(true);

        if (window.confirm("Удалить?")) {
            await post("invoiceDelete", {invoiceId});
        }

        AppComponent.SetLoading(false);
    }

    return (
        <div className={css.invoices}>
            <Dialog setOpen={setOpen} open={open} json={json}/>
            <table>
                <thead>
                <tr>
                    <th>Delete</th>
                    <th>Refund</th>
                    <th>Created</th>
                    <th>AcquiringInvoiceId</th>
                    <th>AcquiringInvoiceRefundId</th>
                    <th>UserId</th>
                    <th>TariffId</th>
                    <th>Months</th>
                    <th>Discount</th>
                    <th>CostWithoutDiscount</th>
                    <th>Cost</th>
                    <th>Active</th>
                    <th>Expired</th>
                    <th>Success</th>
                    <th>AcquiringStatus</th>
                </tr>
                </thead>
                <tbody>
                {invoices.map(invoice => (
                    <tr key={invoice.id} id={invoice.id}>
                        <td>{!invoice.acquiringStatus && <button onClick={() => onInvoiceDelete(invoice.id)}>Delete</button>}</td>
                        <td>{invoice.acquiringInvoiceId && !invoice.acquiringInvoiceRefundId && <button onClick={() => onAcquiringInvoiceRefundClick(invoice.id, invoice.acquiringInvoiceId, invoice.cost)}>Вернуть</button>}</td>
                        <td>{new Date(invoice.created).toLocaleDateString("ru")}</td>
                        <td>{invoice.acquiringInvoiceId && <button onClick={() => showAcquiringInvoice(invoice.acquiringInvoiceId)}>{invoice.acquiringInvoiceId}</button>}</td>
                        <td>{invoice.acquiringInvoiceRefundId && <button onClick={() => showAcquiringInvoiceRefund(invoice.acquiringInvoiceId, invoice.acquiringInvoiceRefundId)}>{invoice.acquiringInvoiceRefundId}</button>}</td>
                        <td>{invoice.userId}</td>
                        <td>{invoice.tariffId}</td>
                        <td>{invoice.months}</td>
                        <td>{invoice.discount}</td>
                        <td>{invoice.costWithoutDiscount}</td>
                        <td>{invoice.cost}</td>
                        <td>{invoice.active}</td>
                        <td>{invoice.expired}</td>
                        <td>{invoice.success}</td>

                        <td>{invoice.acquiringStatus}</td>

                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}
